export type LoginThemeMode = 'off' | 'on' | 'scheduled'
export type LoginThemeConfig = { mode: LoginThemeMode; startsAt: string | null; endsAt: string | null }
export const LOGIN_THEME_SETTING_KEY = 'login_seasonal_theme'
export const DEFAULT_LOGIN_THEME: LoginThemeConfig = { mode: 'off', startsAt: null, endsAt: null }

export function normalizeLoginTheme(value: unknown): LoginThemeConfig {
  try {
    const raw = typeof value === 'string' ? JSON.parse(value) : value
    if (!raw || typeof raw !== 'object') return DEFAULT_LOGIN_THEME
    const row = raw as Record<string, unknown>
    if (row.mode !== 'off' && row.mode !== 'on' && row.mode !== 'scheduled') return DEFAULT_LOGIN_THEME
    const startsAt = typeof row.startsAt === 'string' && Number.isFinite(Date.parse(row.startsAt)) ? new Date(row.startsAt).toISOString() : null
    const endsAt = typeof row.endsAt === 'string' && Number.isFinite(Date.parse(row.endsAt)) ? new Date(row.endsAt).toISOString() : null
    if (row.mode === 'scheduled' && (!startsAt || !endsAt || Date.parse(startsAt) >= Date.parse(endsAt))) return DEFAULT_LOGIN_THEME
    return { mode: row.mode, startsAt, endsAt }
  } catch { return DEFAULT_LOGIN_THEME }
}
export function isChristmasLoginActive(config: LoginThemeConfig, now = Date.now()): boolean {
  if (config.mode === 'on') return true
  if (config.mode !== 'scheduled' || !config.startsAt || !config.endsAt) return false
  return now >= Date.parse(config.startsAt) && now < Date.parse(config.endsAt)
}
